import babelpolyfill from 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-default/index.css';
import VueRouter from 'vue-router';
import store from './vuex/index.js';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import routes from './routes';
import 'font-awesome/css/font-awesome.min.css';
import {
    lg
} from 'utils';
import 'src/lib/js-toast/js-toast.js';

Vue.use(ElementUI);
Vue.use(VueRouter);

NProgress.configure({
    showSpinner: false
});

const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    //NProgress.start();
    if (to.path == '/login') {
        sessionStorage.removeItem('user');
        //return false
    }
    let user = JSON.parse(sessionStorage.getItem('user'));
    if (!user && to.path != '/login') {
        next({
            path: '/login'
        })
    } else {
        if (user) {
            for (var j = 0; j < routes.length; j++) {
                var aj = routes[j];
                aj.hidden = true;
                var childRoutes = aj.children;
                if (childRoutes) {
                    for (let j = 0; j < childRoutes.length; j++) {
                        childRoutes[j].hidden = true;
                    }
                }
            }

            var MenuList = user.MenuList;
            for (var i = 0; i < MenuList.length; i++) {
                var obj = MenuList[i];
                var num = obj.MenuId;
                for (var j = 0; j < routes.length; j++) {
                    var aj = routes[j];
                    var n = aj.MenuId;
                    if (n == num) {
                        aj.hidden = false;
                        var childEachList = obj.EachList;
                        var childRoutes = aj.children;
                        if (childEachList || childRoutes) {
                            for (let i = 0; i < childEachList.length; i++) {
                                for (let j = 0; j < childRoutes.length; j++) {
                                    if (childEachList[i].MenuId == childRoutes[j].MenuId) {
                                        childRoutes[j].hidden = false;
                                    } else {
                                        // childRoutes[j].hidden = true;
                                    }
                                }
                            }
                        } else {
                            console.log('路由匹配出错')
                        }
                    } else {
                        //aj.hidden = true;
                    }
                }

            }

        }
        next();
    }
});
new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js